import "./HorizontalCard.scss";
import cn from "classnames";
import { format } from "date-fns";
import { useMemo, useState } from "react";

export interface HorizontalCardProps {
  leadingElement?: JSX.Element;
  trailingElement?: JSX.Element;
  size?: "sm" | "md" | "lg";
  headerText?: string;
  bodyText: string;
  dateModified?: { date: Date; user: string };
  footer?: JSX.Element;
  onClick?: () => void;
}

export const HorizontalCard = ({
  leadingElement,
  trailingElement,
  size = "md",
  headerText,
  bodyText = "",
  dateModified,
  footer,
  onClick,
}: HorizontalCardProps): JSX.Element => {
  const [pressed, setPressed] = useState<boolean>(false);
  const dateModifiedStr: string | undefined = useMemo(() => {
    if (!dateModified) {
      return undefined;
    }

    const { date, user } = dateModified;
    const dateStr = format(date, "M/d/yy");
    return `Last updated on ${dateStr} by ${user}`;
  }, [dateModified]);

  return (
    <div
      className={cn("horizontalCard", {
        [size]: size,
        interactive: Boolean(onClick),
        disabled: !onClick,
        pressed,
      })}
      onMouseDown={() => setPressed(true)}
      onMouseUp={() => setPressed(false)}
      onMouseLeave={() => setPressed(false)}
      onClick={onClick}
    >
      {leadingElement && <div className="horizontalCardLeading">{leadingElement}</div>}
      <div className="horizontalCardBody">
        {headerText && <div className="horizontalCardHeader">{headerText}</div>}
        <div className="horizontalCardBodyText">{bodyText}</div>
        {dateModifiedStr && <div className="horizontalCardDateModified">{dateModifiedStr}</div>}
        {footer && <div className="horizontalCardFooter">{footer}</div>}
      </div>
      {trailingElement && <div className="horizontalCardTrailing">{trailingElement}</div>}
    </div>
  );
};
